import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { Observable, Subscription } from 'rxjs';

import { Dietitian } from '../../../data/dietitian/domain/dietitian';
import { InvitationTemplate } from '../../../data/dietitian/domain/invitation_template/invitation-template';
import { AccountViewModel } from '../diary/diary/diary.facade';
import { InvitationEditorFacade } from './invitation-editor-facade';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'msd-invitation-editor',
  templateUrl: './invitation-editor.component.html',
  styleUrls: ['./invitation-editor.component.scss'],
  providers: [InvitationEditorFacade],
})
export class InvitationEditorComponent implements OnInit, OnDestroy {
  @Input() visible = false;
  @Input() minRows = 3;
  @Input() maxRows = 10;
  @Input() patientPhoneNumber: string | undefined;
  @Output() changeInvitationTemplate = new EventEmitter<InvitationTemplate>();
  @Output() invalidInvitationTemplate = new EventEmitter<boolean>();
  public sign: string;

  emptyInvitationTemplate: InvitationTemplate;
  defaultInvitationTemplate: InvitationTemplate;
  currentInvitationTemplate: InvitationTemplate;
  invitationsTemplates: InvitationTemplate[];
  private accountStatus$: Observable<AccountViewModel>;
  private accountStatusSubscription: Subscription;
  private dietitian: Dietitian;

  constructor(private facade: InvitationEditorFacade) {
    this.accountStatus$ = this.facade.accountStatus$;

    this.accountStatusSubscription = this.accountStatus$.subscribe((state) => {
      this.dietitian = state.dietitian;
    });

    facade
      .getAllTemplate(this.dietitian.id.toString())
      .then((templates) => (this.invitationsTemplates = templates));
  }

  ngOnDestroy(): void {
    this.accountStatusSubscription?.unsubscribe();
  }

  ngOnInit(): void {
    this.emptyInvitationTemplate = this.facade.getEmptyInvitationTemplate();
    this.defaultInvitationTemplate = this.facade.getDefaultInvitationTemplate();
    this.currentInvitationTemplate = this.defaultInvitationTemplate;
    this.changeInvitationTemplate.emit(this.currentInvitationTemplate);
    this.sign =
      'Si vous êtes intéressé·e je vous invite à :\n' +
      'Installer l’application MonSuiviDiet sur votre smartphone ' +
      "via Google Play ou l' App Store" +
      (this.patientPhoneNumber
        ? ' en entrant votre numéro ' +
          this.patientPhoneNumber +
          ' au moment de l’inscription !'
        : ' !');
  }

  onChangeInvitationTemplate(value: InvitationTemplate) {
    this.currentInvitationTemplate = value;
    this.changeInvitationTemplate.emit(this.currentInvitationTemplate);
    this.invalidInvitationTemplate.emit(
      this.currentInvitationTemplate.content.length === 0,
    );
  }

  onChangeInvitationTemplateContent(content: string) {
    this.currentInvitationTemplate.content = content;
    this.invalidInvitationTemplate.emit(content.length === 0);
    this.changeInvitationTemplate.emit(this.currentInvitationTemplate);
  }
}
